import { useEffect, useRef } from "react";
import { useGetBitrixDataQuery } from "../api/commonApi";

const MAX_RETRIES = 5;

export function useBitrixData(isAuthorized: boolean) {
  const { data, isError, refetch } = useGetBitrixDataQuery(undefined, { skip: !isAuthorized });

  const retryCountRef = useRef(0);

  useEffect(() => {
    if (isAuthorized && !isError && data) {
      retryCountRef.current = 0;
    }
  }, [isAuthorized, isError, data]);

  useEffect(() => {
    if (isAuthorized && isError && retryCountRef.current < MAX_RETRIES) {
      retryCountRef.current += 1;
      const timeoutId = setTimeout(() => {
        refetch();
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [isAuthorized, isError, refetch]);

  return { data, isError };
}
